module.exports = __webpack_public_path__ + "img/angle-90.66cd2d42.svg";